import { InlineErrorProvider } from '@/context/InlineErrorContext/InlineErrorContext';
import { ReceivedInvoiceDetail } from '@/context/services/invoice/type';
import { Details } from '@/features/invoices/components/Details';
import { AiSuggestStatusProvider } from '@/features/invoices/components/Details/Components/Context/AiSuggestStatus';
import { OperationStatusProvider } from '@/features/invoices/components/Details/Components/Context/OperationStatus';
import {
  DrawerTitle,
  LoadingDrawerTitle,
} from '@/features/invoices/components/List/Table/Drawer/components/DrawerTitle';
import { useGetFlags } from '@/hooks/useFeatureFlag';
import { DraggableDrawer } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo, useCallback, useEffect, useMemo, useState } from 'react';
import styles from './Drawer.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  selectedId: string;
  onClose: () => void;
};
export const Drawer: FC<Props> = memo(({ onClose, selectedId }) => {
  const flag = useGetFlags('RECEIVED_INVOICE_COPY_BUTTON');
  const minWidth = useMemo(() => (flag ? 968 : 986), [flag]);
  const [width, setWidth] = useState(minWidth);
  const [data, setData] = useState<ReceivedInvoiceDetail | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  const onCloseDrawer = useCallback(() => {
    setData(null);
    onClose();
  }, [onClose]);

  useEffect(() => {
    setWidth(minWidth);
  }, [minWidth]);
  return (
    <OperationStatusProvider value={data?.operation_status}>
      <AiSuggestStatusProvider value={data?.ai_suggest_status}>
        <InlineErrorProvider>
          <DraggableDrawer
            width={width}
            setWidth={setWidth}
            visible={!!selectedId}
            onClose={onCloseDrawer}
            contentContainerClassName={cx(styles['contentContainer'])}
            minWidth={minWidth}
            title={
              data && !isLoading ? (
                <DrawerTitle data={data} />
              ) : (
                <LoadingDrawerTitle />
              )
            }
          >
            {selectedId && (
              <Details
                key={selectedId}
                invoiceId={selectedId}
                setData={setData}
                setIsLoading={setIsLoading}
              />
            )}
          </DraggableDrawer>
        </InlineErrorProvider>
      </AiSuggestStatusProvider>
    </OperationStatusProvider>
  );
});

Drawer.displayName = 'Drawer';
